import Heading from "components/Typography/Heading"
import styled from "styled-components"
import Switch from "components/EvtKit/switch/Switch"

const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 112px;
  width: 100%;
`

const ContentRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
`

const SwitchButton = styled.button`
  height: fit-content;
  width: fit-content;
`

interface CellSwitchProps {
  initialState?: boolean
  onClickSwitch?: () => void
}

export const CellSwitch = (props: CellSwitchProps) => {
  const { initialState, onClickSwitch } = props

  return (
    <ContentColumn>
      <ContentRow>
        <SwitchButton onClick={onClickSwitch}>
          <Switch value={initialState} />
        </SwitchButton>
        <Heading variant="xs">{initialState ? "Publicado" : "Não publicado"}</Heading>
      </ContentRow>
    </ContentColumn>
  )
}
